import { render, staticRenderFns } from "./SuppliersPage.vue?vue&type=template&id=b967f24c"
import script from "./SuppliersPage.vue?vue&type=script&lang=ts"
export * from "./SuppliersPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports